module.exports = __webpack_public_path__ + "img/icon_huodong@2x.0e2574c3.png";